// Piece Skins Configuration
// Centralized configuration for all chess piece skin images
// Each skin provides images for all standard chess pieces (king, queen, rook, bishop, knight, pawn)

export const PIECE_SKIN_IMAGES = {
  // Neo Classic - Clean modern style (Free option using Lichess cburnett pieces - GPLv2+)
  neo: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wP.svg'
  },
  // Neo Dark - Clean modern style for black pieces (GPLv2+)
  neoDark: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bP.svg'
  },
  // Merida - Classic tournament style (GPLv2+ - Free for commercial use)
  merida: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wP.svg'
  },
  meridaDark: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bP.svg'
  },
  // Shapes - Abstract geometric pieces (CC BY-SA 4.0 - Free for commercial use with attribution)
  shapes: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wP.svg'
  },
  shapesDark: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bP.svg'
  },
  // Kiwen Suwi - Stylized pieces (CC BY 4.0 - Free for commercial use with attribution)
  kiwenSuwi: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wP.svg'
  },
  kiwenSuwiDark: {
    king: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bK.svg',
    queen: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bQ.svg',
    rook: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bR.svg',
    bishop: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bB.svg',
    knight: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bN.svg',
    pawn: 'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bP.svg'
  },
  // Golden 3D Pieces - Luxurious gold metallic style
  golden: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/zmrne0bi_King.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/p2wnhr52_Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/xbuggp7i_Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/huzeh3i2_bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/60qlkbm7_Knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/2y0fo3op_Pawn.png'
  },
  // Obsidian 3D Pieces - Sleek glossy black style
  obsidian: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/d0p2uu4l_black%20kingpng.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/rrxl5ktg_blackqueen%29.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/t6yqe2r6_Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/eenvybri_Bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/gqsl7hca_horseknight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/yqd2kaiq_black%20pawn.png'
  },
  // Vintage/Medieval - Hand-drawn engraved style
  vintage: {
    king: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/2tx2ybcg_King.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/hk7etiwm_Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/yr7vp4p1_Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/yg5f3dl8_bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/hftt23bi_Knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/atkrr4w9_pawn.png'
  },
  // Kawaii - Cute brown emoji pieces
  kawaii: {
    king: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/9u70ags6_Brown%20King.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/3k5p9kj0_Brown%20Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/8nmepr0r_Brown%20Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/t1xf6fxf_Brown%20Bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/xuh2s6z3_Brown%20knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/j9ns159d_Brown%20pawn.png'
  },
  // Kawaii White - Cute white emoji pieces
  kawaiiWhite: {
    king: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/r1bm2e11_White%20King%20.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/njnquebi_White%20Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/y1haibcs_White%20rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/i03obfuq_White%20bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/cd0oosfn_White%20Knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/co84ftxh_White%20pawn.png'
  },
  // Kawaii Black - Cute black emoji pieces with gold accents
  kawaiiBlack: {
    king: 'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/omu9ftg2_Black%20King.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/79hg6q9r_Black%20Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/8kh8o13u_Black%20Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/gy6oeqna_Black%20bishop%20.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/6k32omak_Blackknight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/5uiey2a5_Black%20pawn.png'
  },
  // Kawaii Beige - Cute beige/tan emoji pieces
  kawaiiBeige: {
    king: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/m67ax4wy_baige%20king.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/0k72km65_baige%20queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/4h9ktdlu_baige%20Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/itn53p1y_baige%20bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/0zbap5z8_baige%20knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/5uwi6k96_baige%20pawn.png'
  },
  // Vintage Black - Dark hand-drawn engraved medieval style
  vintageBlack: {
    king: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/ttl3facz_blkking.png',
    queen: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/b5g7rvii_blkqueen.png',
    rook: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/1umncyf7_blkrook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/sbgrxx09_blkbishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/69xjqj40_blkknight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/a4pfkf3z_blkPawn.png'
  },
  // Fable Black - Medieval armored warriors (dark style)
  fableBlack: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/ywqogvww_Fable%20King%20Black.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/6hi4uzne_Fable%20Queen%20Black.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/vqsxo9eu_Fable%20Rook%20Black.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/6agoec9r_Fable%20Bishop%20Black.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/s3eiyag2_Fable%20Knight%20Black.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/6j34st8l_Fable%20Pawn%20Black.png'
  },
  // Fable White - Medieval crusader knights in white/silver armor
  fableWhite: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/o29b9eux_Fable%20King%20white.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/g9m3aoue_Fable%20Queen%20white.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/bwrnoby7_Fable%20Rook%20white.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/4bwdaclq_Fable%20Bishop%20white.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/lku3lwyb_Fable%20Knight%20white.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/nbyxrnk7_Fable%20Pawn%20white.png'
  },
  // Gothic Black - Majestic dark gothic pieces
  gothicBlack: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/0hhcvpg7_Black%20KIng.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/mzb2cvnn_Black%20Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/m5mnh42t_Rook2.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/14bv55g0_Black%20bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/96uvm8uy_Black%20Knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/zon08lbm_black%20pawn%20%29.png'
  },
  // Gothic White - Radiant white gothic pieces
  gothicWhite: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/k3afls8k_White%20KIng.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/sdijgv24_white%20Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/4h90kjpe_Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/oarstytx_White%20bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/ajdhm9p8_white%20Knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/suchf31l_White%20Pawn.png'
  },
  // Vintage Medieval - Carved wooden/bronze style pieces
  vintageMedieval: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/5y425oo1_King%20.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/5q4dulgc_Queen.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/zzgy0lx0_Rook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/s7znswsa_bishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/iqk0mqo1_knight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/zq4errkt_pawn.png'
  },
  // Colossal White - Epic marble/white stone sculpted pieces
  colossalWhite: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/mbxdsi5j_superKing%20white.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/6r8y2vvi_superQueen%20white.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/g9iemfcp_superRook%20white.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/18fnsbxp_superBishop%20white.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/ohwrh7xe_superKnight%20white.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/1wf9yqp4_superPawn%20white.png'
  },
  // Colossal Bronze - Epic dark bronze sculpted pieces
  colossalBronze: {
    king: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/cm5sb8u6_superKing%20bronze.png',
    queen: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/1f4hgkz7_superQueen%20bronze.png',
    rook: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/8ruqwqba_superRook%20Bronze.png',
    bishop: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/sczcxjbi_superBishop%20bronze.png',
    knight: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/my0phb7k_superKnight%20Bronze.png',
    pawn: 'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/av5g5cw9_super%20Pawn%20Bronze.png'
  },
  // Amethyst Purple - Beautiful stained-glass purple gemstone pieces
  amethystPurple: {
    king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/uulzopfh_kingpurple.png',
    queen: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/pxr4cv34_Queenpurple.png',
    rook: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/ggf1ppb3_Rookpurple.png',
    bishop: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/k7kal9ve_Bishoppurple.png',
    knight: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/jlo0m1hi_Knightpurple.png',
    pawn: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/5tobce8s_Pawnpurple.png'
  },
  // Sapphire Blue - Beautiful stained-glass blue gemstone pieces
  sapphireBlue: {
    king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/dmet5a4g_kingpsapphireblue.png',
    queen: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/m0m8sku3_queensapphireblue.png',
    rook: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/40oqwrex_Rooksapphireblue.png',
    bishop: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/qzxmj9wm_Bishopsapphireblue.png',
    knight: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/sf1jmtkx_Knightsapphireblue.png',
    pawn: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/x30hf4p4_Pawnsapphireblue.png'
  },
  // Stone and Sand Kingdom - Epic sand/stone golem warriors
  stoneSand: {
    king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/x9dczv8c_sandking2.png',
    queen: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/5hq29tpm_sandQueen.png',
    rook: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/y7njgkwo_sandRook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/lskmxw1e_sandbishop1.5.png',
    knight: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/sdjyiifk_sandKnight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/r1h19b3w_sandPawng.png'
  },
  // Woodlin Warriors Kingdom - Ancient forest tree warriors
  woodlinWarriors: {
    king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/u3nnk32c_woodlenrealking2.png',
    queen: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/iauu4nce_woodlenrealQueen2.png',
    rook: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/tzmq3m2t_woodlenRook.png',
    bishop: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/8nnn82es_woodlenBishop.png',
    knight: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/e0b84qjk_woodlenKnight.png',
    pawn: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/zll3dk3f_woodlenPawn.png'
  }
};

// Helper function to get piece image
export const getPieceImage = (skinId, pieceType) => {
  const skin = PIECE_SKIN_IMAGES[skinId];
  return skin ? skin[pieceType] : null;
};

// Skin categories for styling
export const SKIN_CATEGORIES = {
  neo: ['neo', 'neoDark'],
  merida: ['merida', 'meridaDark'],
  shapes: ['shapes', 'shapesDark'],
  kiwenSuwi: ['kiwenSuwi', 'kiwenSuwiDark'],
  kawaii: ['kawaii', 'kawaiiWhite', 'kawaiiBlack', 'kawaiiBeige'],
  vintage: ['vintage', 'vintageBlack', 'vintageMedieval'],
  fable: ['fableWhite', 'fableBlack'],
  gothic: ['gothicWhite', 'gothicBlack'],
  colossal: ['colossalWhite', 'colossalBronze'],
  gemstone: ['amethystPurple', 'sapphireBlue'],
  kingdom: ['stoneSand', 'woodlinWarriors'],
  standard: ['golden', 'obsidian']
};

// Get skin category for CSS styling
export const getSkinCategory = (skinId) => {
  for (const [category, skins] of Object.entries(SKIN_CATEGORIES)) {
    if (skins.includes(skinId)) return category;
  }
  return 'standard';
};

// Piece Skins UI Array - Used for settings selector with preview images
export const PIECE_SKINS_UI = [
  { id: null, name: 'Classic', preview: [], isDefault: true },
  // === FREE OPEN SOURCE COLLECTION (Safe for commercial use) ===
  { 
    id: 'neo', 
    name: 'Neo (White)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/wN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'neoDark', 
    name: 'Neo (Black)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/cburnett/bN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'merida', 
    name: 'Merida (White)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/wN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'meridaDark', 
    name: 'Merida (Black)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/merida/bN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'shapes', 
    name: 'Shapes (White)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/wN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'shapesDark', 
    name: 'Shapes (Black)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/shapes/bN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'kiwenSuwi', 
    name: 'Kiwen Suwi (White)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/wN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  { 
    id: 'kiwenSuwiDark', 
    name: 'Kiwen Suwi (Black)',
    preview: [
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bK.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bQ.svg',
      'https://raw.githubusercontent.com/lichess-org/lila/master/public/piece/kiwen-suwi/bN.svg'
    ],
    badge: '🆓',
    isFree: true
  },
  // === PREMIUM SKINS ===
  { 
    id: 'golden', 
    name: 'Golden 3D',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/zmrne0bi_King.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/p2wnhr52_Queen.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/60qlkbm7_Knight.png'
    ],
    badge: 'Premium'
  },
  { 
    id: 'obsidian', 
    name: 'Obsidian 3D',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/d0p2uu4l_black%20kingpng.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/rrxl5ktg_blackqueen%29.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/gqsl7hca_horseknight.png'
    ],
    badge: 'Premium'
  },
  { 
    id: 'vintage', 
    name: 'Vintage',
    preview: [
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/2tx2ybcg_King.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/hk7etiwm_Queen.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/hftt23bi_Knight.png'
    ],
    badge: 'Premium'
  },
  { 
    id: 'vintageBlack', 
    name: 'Vintage Black',
    preview: [
      'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/ttl3facz_blkking.png',
      'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/b5g7rvii_blkqueen.png',
      'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/69xjqj40_blkknight.png'
    ],
    badge: 'Premium'
  },
  { 
    id: 'kawaii', 
    name: 'Kawaii Brown',
    preview: [
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/9u70ags6_Brown%20King.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/4zvyi164_Brown%20Queen.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/vwidsonu_Brown%20knight.png'
    ],
    badge: '😊'
  },
  { 
    id: 'kawaiiWhite', 
    name: 'Kawaii White',
    preview: [
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/r1bm2e11_White%20King%20.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/slvgd52p_White%20Queen.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/l2ge2osq_White%20Knight.png'
    ],
    badge: '🤍'
  },
  { 
    id: 'kawaiiBlack', 
    name: 'Kawaii Black',
    preview: [
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/omu9ftg2_Black%20King.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/8fuealrf_Black%20Queen.png',
      'https://customer-assets.emergentagent.com/job_boardbattles-3/artifacts/nv2z9tkf_Blackknight.png'
    ],
    badge: '🖤'
  },
  { 
    id: 'kawaiiBeige', 
    name: 'Kawaii Beige',
    preview: [
      'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/0k72km65_baige%20queen.png',
      'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/0zbap5z8_baige%20knight.png',
      'https://customer-assets.emergentagent.com/job_boardware-custom/artifacts/5uwi6k96_baige%20pawn.png'
    ],
    badge: '🧡'
  },
  { 
    id: 'fableBlack', 
    name: 'Fable Black',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/ywqogvww_Fable%20King%20Black.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/6hi4uzne_Fable%20Queen%20Black.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/s3eiyag2_Fable%20Knight%20Black.png'
    ],
    badge: '🏰'
  },
  { 
    id: 'fableWhite', 
    name: 'Fable White',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/o29b9eux_Fable%20King%20white.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/g9m3aoue_Fable%20Queen%20white.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/lku3lwyb_Fable%20Knight%20white.png'
    ],
    badge: '⚔️'
  },
  { 
    id: 'gothicBlack', 
    name: 'Gothic Black',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/0hhcvpg7_Black%20KIng.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/mzb2cvnn_Black%20Queen.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/96uvm8uy_Black%20Knight.png'
    ],
    badge: '🖤'
  },
  { 
    id: 'gothicWhite', 
    name: 'Gothic White',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/k3afls8k_White%20KIng.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/sdijgv24_white%20Queen.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/ajdhm9p8_white%20Knight.png'
    ],
    badge: '🤍'
  },
  { 
    id: 'vintageMedieval', 
    name: 'Vintage Medieval',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/5y425oo1_King%20.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/5q4dulgc_Queen.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/iqk0mqo1_knight.png'
    ],
    badge: '📜'
  },
  { 
    id: 'colossalWhite', 
    name: 'Colossal White',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/mbxdsi5j_superKing%20white.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/6r8y2vvi_superQueen%20white.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/ohwrh7xe_superKnight%20white.png'
    ],
    badge: '🔱'
  },
  { 
    id: 'colossalBronze', 
    name: 'Colossal Bronze',
    preview: [
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/cm5sb8u6_superKing%20bronze.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/1f4hgkz7_superQueen%20bronze.png',
      'https://customer-assets.emergentagent.com/job_85ebdb0b-c856-4baf-9e55-ba0cd8064999/artifacts/my0phb7k_superKnight%20Bronze.png'
    ],
    badge: '🏛️'
  },
  { 
    id: 'amethystPurple', 
    name: 'Amethyst Purple',
    preview: [
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/uulzopfh_kingpurple.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/pxr4cv34_Queenpurple.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/jlo0m1hi_Knightpurple.png'
    ],
    badge: '💎'
  },
  { 
    id: 'sapphireBlue', 
    name: 'Sapphire Blue',
    preview: [
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/dmet5a4g_kingpsapphireblue.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/m0m8sku3_queensapphireblue.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/sf1jmtkx_Knightsapphireblue.png'
    ],
    badge: '💙'
  },
  { 
    id: 'stoneSand', 
    name: 'Stone & Sand Kingdom',
    preview: [
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/x9dczv8c_sandking2.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/5hq29tpm_sandQueen.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/sdjyiifk_sandKnight.png'
    ],
    badge: '🏜️'
  },
  { 
    id: 'woodlinWarriors', 
    name: 'Woodlin Warriors Kingdom',
    preview: [
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/u3nnk32c_woodlenrealking2.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/iauu4nce_woodlenrealQueen2.png',
      'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/e0b84qjk_woodlenKnight.png'
    ],
    badge: '🌲'
  }
];
